export enum TipPresetButtonType {
  PERCENTAGE = "PERCENTAGE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
  NO_TIP = "NO_TIP",
  ENTER_AMOUNT = "ENTER_AMOUNT",
}
